var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushcredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_18329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.42859C0 10.0201 0.559896 10.5 1.25 10.5H13.75C14.4401 10.5 15 10.0201 15 9.42859V5.50001H0V9.42859ZM5 7.91073C5 7.76341 5.14062 7.64287 5.3125 7.64287H8.85416C9.02604 7.64287 9.16667 7.76341 9.16667 7.91073V8.8036C9.16667 8.95092 9.02604 9.07145 8.85416 9.07145H5.3125C5.14062 9.07145 5 8.95092 5 8.8036V7.91073ZM1.66667 7.91073C1.66667 7.76341 1.80729 7.64287 1.97917 7.64287H3.85417C4.02604 7.64287 4.16666 7.76341 4.16666 7.91073V8.8036C4.16666 8.95092 4.02604 9.07145 3.85417 9.07145H1.97917C1.80729 9.07145 1.66667 8.95092 1.66667 8.8036V7.91073ZM15 1.57144V2.64286H0V1.57144C0 0.979912 0.559896 0.5 1.25 0.5H13.75C14.4401 0.5 15 0.979912 15 1.57144Z",
    fill: "#6CBECD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_18329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushcredit);
export default __webpack_public_path__ + "static/media/pushcredit.04915d77ad3917250de2702086442ae0.svg";
export { ForwardRef as ReactComponent };